module.exports = __webpack_public_path__ + "img/kommune-1428.aa907649.svg";